import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Loader, MessageBlock } from '@getro/rombo';
import { Flex, Text } from 'rebass/styled-components';
import strings from 'strings';
import { SuccessMessageBanner } from './SuccessMessageBanner';

const JobMessage = ({ type, editing, expirationDate, onClick }) => {
  const title = useMemo(() => {
    if (type === 'loading_error') {
      return strings.genericError;
    }

    if (type === 'success' && !editing) {
      if (!expirationDate) {
        return 'Job successfully posted';
      }

      return strings.expirationDate[expirationDate.value];
    }

    return 'Job successfully updated';
  }, [editing, expirationDate, type]);

  const messageType = useMemo(() => {
    if (type === 'loading_error') {
      return 'error';
    }

    return 'success';
  }, [type]);

  if (type === 'loading') {
    return <Loader data-testid="job-message-loader" />;
  }

  return (
    <Flex sx={{ maxWidth: '480px', margin: '0 auto', flexDirection: 'column', rowGap: '40px' }}>
      <MessageBlock type={messageType} title={title}>
        {expirationDate && (
          <Text fontSize="2" color="text.main">
            {expirationDate.value > 0 && <>We will email you before it expires.</>}
            {expirationDate.value === 0 && <>We will email you occasionally to review it.</>}
          </Text>
        )}
      </MessageBlock>

      <SuccessMessageBanner />

      <Text
        as="a"
        href="#"
        sx={{
          fontSize: '14px',
          textAlign: 'center',
          textDecoration: 'underline',
          cursor: 'pointer',
          mt: '16px',
        }}
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      >
        Go to jobs screen
      </Text>
    </Flex>
  );
};

JobMessage.propTypes = {
  editing: PropTypes.bool,
  onClick: PropTypes.func,
  expirationDate: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  }),
  type: PropTypes.oneOf(['loading', 'loading_error', 'success']).isRequired,
};

JobMessage.defaultProps = {
  editing: false,
  expirationDate: null,
  onClick: () => {},
};

export default JobMessage;
